<template>
  <span class="serp__filters--marked-item" v-for="(activeFilter, filterName) in getActiveFilters" :key="filterName">
    <MarkedFilterButton v-if="typeof activeFilter.min === 'undefined' && typeof activeFilter.max === 'undefined'" :active-filter="activeFilter" :filter-name="filterName"/>
    <MarkedFilterRangeButton v-else :active-filter="activeFilter" :filter-name="filterName"/>
  </span>
</template>

<script setup lang="ts">
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {storeToRefs} from "pinia";
import MarkedFilterButton from './MarkedFilterButton.vue'
import MarkedFilterRangeButton from './MarkedFilterRangeButton.vue'

const filtersStore = useFiltersStore();
const {getActiveFilters} = storeToRefs(filtersStore)

</script>
